import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { crewService } from '@services/crew';
import { CREW_QUERY_KEY } from './useCrew';
import { CREWS_BY_USER_QUERY_KEY } from './useCrews';
import { EMPLOYEES_QUERY_KEY } from '@hooks/api/employees/useEmployees';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export type UnassignEmployeeArgs = {
  crewId: string;
  employeeId: string;
};

export const useCrewUnassignEmployee = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['crew', 'unassignEmployee'],
    mutationFn: async ({ crewId, employeeId }: UnassignEmployeeArgs) => {
      if (!crewId) throw new Error('crewId is required');
      if (!employeeId) throw new Error('employeeId is required');
      return await crewService.unassignEmployee(crewId, employeeId);
    },
    onSuccess: (crew) => {
      toast.success(tActionMessages.employeeUnassignedSuccessfully);
      queryClient.invalidateQueries({ queryKey: CREW_QUERY_KEY(crew.crewId) });
      queryClient.invalidateQueries({ queryKey: CREWS_BY_USER_QUERY_KEY });
      // Membership changed, so every employee's `crews` list is now stale.
      queryClient.invalidateQueries({ queryKey: EMPLOYEES_QUERY_KEY });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useCrewUnassignEmployee;
